import React from "react";

import {
  Cell,
  Legend,
  Pie,
  PieChart as RechartsPieChart,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
} from "recharts";

import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";
import { StatusDistributionChartProps } from "~/pages/purchase-orders/types/sales-notes";

export const StatusDistributionChart: React.FC<
  StatusDistributionChartProps
> = ({ statusDistribution }) => {
  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">Distribución por Estado</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="h-[250px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <RechartsPieChart>
              <Pie
                data={statusDistribution}
                cx="50%"
                cy="50%"
                labelLine={statusDistribution.length <= 3}
                label={
                  statusDistribution.length <= 3
                    ? ({ name, percent }: { name: string; percent: number }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                    : undefined
                }
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {statusDistribution.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <RechartsTooltip
                formatter={(value: number) => [`${value} notas`, "Cantidad"]}
                itemSorter={(item: { value: number }) => -item.value}
              />
              {statusDistribution.length > 3 && (
                <Legend
                  layout="vertical"
                  align="right"
                  verticalAlign="middle"
                />
              )}
            </RechartsPieChart>
          </ResponsiveContainer>
        </div>
        {statusDistribution.length === 0 && (
          <div className="flex h-40 items-center justify-center text-sm text-muted-foreground">
            No hay datos para mostrar
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default StatusDistributionChart;
